module.exports = __webpack_public_path__ + "media/images/regional-image17-0b63166818eaa14546296881464d2d6e.jpg";